import React from 'react';

export default function EnergyVisualizer({ isSpeaking, isRecording, timeLeft = 300 }) {
  const getStatusClass = () => {
    if (isSpeaking) {
      return "bg-blue-500";
    } else if (isRecording) {
      return "bg-green-500";
    } else {
      return "bg-yellow-500";
    }
  };

  const statusClass = getStatusClass();
  const animationDuration = isSpeaking || isRecording ? '0.6s' : '1.2s';

  return (
    <div className={`flex items-center justify-center p-4 ${statusClass} rounded-lg`}>
      <div className="flex items-end gap-1 h-12">
        {[...Array(5)].map((_, index) => (
          <div
            key={index}
            className={`w-2 bg-white rounded-t ${statusClass} animate-pulse`}
            style={{
              height: `${20 + index * 15}%`,
              animationDelay: `${index * 0.1}s`,
              animationDuration: animationDuration
            }}
          />
        ))}
      </div>
    </div>
  );
}
